
        import { NgModule } from '@angular/core';
        import { ProgramasRoutingModule } from './programas-routing.module';
        import { ProgramaService } from './services/programa.service';
  
        @NgModule({
          declarations: [],
          imports: [
            ProgramasRoutingModule
          ],
          providers: [
            ProgramaService
          ]
        })
        export class ProgramasModule { }
    